import { render, staticRenderFns } from "./scene-question.vue?vue&type=template&id=8e439c1c&scoped=true&"
import script from "./scene-question.vue?vue&type=script&lang=js&"
export * from "./scene-question.vue?vue&type=script&lang=js&"
import style0 from "./scene-question.vue?vue&type=style&index=0&id=8e439c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e439c1c",
  null
  
)

export default component.exports